import React, { useMemo } from 'react';
import { Typography } from 'seagull';
import { MailSentLine18 } from 'seagull/icons';
import { activityLogModel, timeModel } from "../../../models";
import styles from "./ProposalStatusLog.module.scss";
import { useIoContext } from "../../../contexts";
export function Reminders(_ref) {
  let {
    reminders,
    progressStatus,
    relationshipProgressStatus,
    isReminderInProgress
  } = _ref;
  const showReminderInProgress = isReminderInProgress && relationshipProgressStatus === progressStatus;
  const {
    getNow
  } = useIoContext();
  const now = useMemo(() => getNow(), []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.divider
  }), /*#__PURE__*/React.createElement("div", {
    "data-testid": "step-".concat(progressStatus, "-reminders"),
    className: styles.reminders
  }, reminders.map((reminder, index) => /*#__PURE__*/React.createElement(Reminder, {
    key: index,
    testid: "reminder-".concat(index),
    title: getReminderTitle(reminder),
    timestamp: activityLogModel.timestamp(reminder)
  })), showReminderInProgress ? /*#__PURE__*/React.createElement(Reminder, {
    testid: "reminder-in-progress",
    title: "Reminder in progress",
    timestamp: now
  }) : null));
}
const Reminder = _ref2 => {
  let {
    title,
    timestamp,
    testid
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testid,
    className: styles.reminder
  }, /*#__PURE__*/React.createElement("div", {
    "data-testid": "reminder-title",
    className: styles.title
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2"
  }, title), /*#__PURE__*/React.createElement(MailSentLine18, null)), /*#__PURE__*/React.createElement("div", {
    "data-testid": "reminder-timestamp"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph3"
  }, timeModel.formatDateWithTime(timestamp))));
};
const getReminderTitle = reminder => {
  var _reminder$data$vendor, _channelToCopy$channe;
  const vendorName = (_reminder$data$vendor = reminder.data.vendor) === null || _reminder$data$vendor === void 0 ? void 0 : _reminder$data$vendor.name;
  const agreementChannel = activityLogModel.isAgreementEntry(reminder) && activityLogModel.agreementChannel(reminder);
  const channel = agreementChannel || activityLogModel.Channel.Email;
  const channelToCopy = {
    [activityLogModel.Channel.Email]: 'Email',
    [activityLogModel.Channel.Sms]: 'Text'
  };
  const reminderStateToTitle = {
    signingReminderSent: "Automatic ".concat((_channelToCopy$channe = channelToCopy[channel]) === null || _channelToCopy$channe === void 0 ? void 0 : _channelToCopy$channe.toLowerCase(), " reminder sent by Anchor"),
    signingReminderSentManual: vendorName ? "".concat(channelToCopy[channel], " reminder sent by ").concat(vendorName) : 'Agreement approval reminder sent',
    microDepositReminderSent: 'Micro deposit reminder sent'
  };
  return reminderStateToTitle[reminder.state];
};